import { Connection, Transaction, Signer, TransactionInstruction, ComputeBudgetProgram } from '@solana/web3.js';
import { WalletContextState } from '@solana/wallet-adapter-react';

export async function sendTx(
  connection: Connection,
  wallet: Pick<WalletContextState, 'publicKey' | 'signTransaction'>,
  instructions: TransactionInstruction[],
  signers: Signer[] = []
) {
  const tx = new Transaction().add(...instructions);
  tx.feePayer = wallet.publicKey!;
  tx.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
  const addPriorityFee = ComputeBudgetProgram.setComputeUnitPrice({
    microLamports: 1300000,
  });
  const withPriorityFee = tx.add(addPriorityFee)

  const signed = await wallet.signTransaction!(withPriorityFee);
  const txId = await connection.sendRawTransaction(signed.serialize());
  await connection.confirmTransaction(txId);
  return txId;
}

